import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

type DivProps = {
	width?: string;
};

export const RootStyle = styled('div')({
	display: 'flex',
	minHeight: '100vh',
	overflow: 'hidden',
});

export const MainStyle = styled('div')(({ theme }) => ({
	flexGrow: 1,
	overflow: 'hidden',
	minHeight: '100%',
	background: theme.palette.background.paper,
	position: 'relative',
}));

export const LayoutColumns = styled(Grid)(() => ({
	flexDirection: 'row',
	display: 'flex',
	width: '100%',
}));

export const LayoutColumn = styled('div')<DivProps>(({ width }) => {
	return {
		width: width || '100%',
		minHeight: '100%',
	};
});

export const LayoutRows = styled(Grid)(() => ({
	flexDirection: 'row',
	display: 'flex',
}));

export const LayoutRow = styled('div')<DivProps>(({ width }) => {
	return {
		width: width || '100%',
		minHeight: '100%',
	};
});
